import { Routes } from '@angular/router';
import { LoginGuard } from './shared/guards/login.guard';
import { DetailsGuard } from './shared/guards/details.guard';
import { CanDeactivateGuard } from './shared/guards/candeactivate.guard';
import { PageNotFoundComponent } from './shared/page-not-found/page-not-found.component';
// import { MsalGuard } from './msal/guards/msal.guard';
import { MsalGuard } from '@azure/msal-angular';
import { SiteRequestDetailsComponent } from './feature/approvals/components/site-request-details/site-request-details.component';
import { LoginTypeGuard } from './shared/guards/login-type.guard';
import { ExternalLoginGuardGuard } from './shared/guards/external-login-guard.guard';
import { IsLoggedInGuard } from './shared/guards/is-logged-in.guard';
import { IsInternalUserGuard } from './shared/guards/is-internal-user.guard';
import { BehaviorSubject } from 'rxjs';

const jsChunkError = new BehaviorSubject(false);

export const getJsChunkError = () => {
  return jsChunkError.asObservable();
}

const setJsChunkError = () =>  {
  jsChunkError.next(true);
}

export const routes: Routes = [

  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  {
    path: 'login',
    loadChildren: () => import("./feature/login/login.module").then(m => m.LoginModule).catch(error => setJsChunkError()),
    canActivate: [IsLoggedInGuard]
  },
  {
    path: 'external',
    loadChildren: () => import("./feature/login/external-login/external-login.module").then(m => m.ExternalLoginModule).catch(error => setJsChunkError()),
    canActivate: [LoginTypeGuard]
  },
  {
    path: 'internal',
    loadChildren: () => import("./feature/login/internal-login/internal-login.module").then(m => m.InternalLoginModule).catch(error => setJsChunkError()),
    canActivate: [LoginTypeGuard, MsalGuard],
  },
  {
    path: 'register',
    loadChildren: () => import("./feature/login/register/register.module").then(m => m.RegisterModule).catch(error => setJsChunkError()),
    canActivate: [ExternalLoginGuardGuard]
  },
  {
    path: 'forgotpassword',
    loadChildren: () => import("./feature/login/forget-password/forget-password.module").then(m => m.ForgetPasswordModule).catch(error => setJsChunkError()),
    canActivate: [ExternalLoginGuardGuard]
  },
  {
    path: 'resetpassword',
    loadChildren: () => import("./feature/login/reset-password/reset-password.module").then(m => m.ResetPasswordModule).catch(error => setJsChunkError()),
    canActivate: [ExternalLoginGuardGuard]
  },
  {
    path: 'proxyaddmember',
    loadChildren: () => import("./feature/proxy/proxy-add-member/proxy-add-member.module").then(m => m.ProxyAddMemberModule).catch(error => setJsChunkError()),
    canActivate: [LoginGuard]
  },
  {
    path: 'detail',
    loadChildren: () => import("./feature/detail/detail.module").then(m => m.DetailModule).catch(error => setJsChunkError()),
    canActivate: [DetailsGuard],
    canDeactivate: [CanDeactivateGuard]
  },
  {
    path: 'history',
    loadChildren: () => import("./feature/history/history.module").then(module => module.HistoryModule).catch(error => setJsChunkError()),
    canActivate: [LoginGuard]
  },
  {
    path: 'scanqr',
    loadChildren: () => import("./feature/scan-qr-code/scan-qr-code.module").then(module => module.ScanQrCodeModule).catch(error => setJsChunkError()),
    canActivate: [LoginGuard]
  },
  {
    path: 'inviteuser',
    canActivate: [LoginGuard],
    loadChildren: () => import("./feature/invite-user/invite-user.module").then(module => module.InviteUserModule).catch(error => setJsChunkError())
  },
  {
    path: 'siteredinessmatrix',
    canActivate: [LoginGuard],
    loadChildren: () => import("./feature/site-rediness-matrix/site-readiness-matrix.module").then(m => m.SiteReadinessMatrixModule).catch(error => setJsChunkError())
  },
  {
    path: 'sitecreatereq',
    loadChildren: () => import("./feature/site-rediness-matrix/templates/create-request/create-request.module").then(m => m.CreateRequestModule).catch(error => setJsChunkError()),
    canActivate: [LoginGuard],
  },
  {
    path: 'reqdetails',
    loadChildren: () => import("./feature/site-rediness-matrix/templates/request-details/request-details.module").then(m => m.RequestDetailsModule).catch(error => setJsChunkError()),
    canActivate: [LoginGuard],
  },
  {
    path: 'grpdetail',
    loadChildren: () => import("./feature/proxy/proxy-group-details/proxy-group-details.module").then(m => m.ProxyGroupDetailsModule).catch(error => setJsChunkError()),
    canActivate: [LoginGuard]
  },
  {
    path: 'settings',
    canActivate: [LoginGuard],
    loadChildren: () => import("./feature/setting/setting.module").then(module => module.SettingModule).catch(error => setJsChunkError())
  },
  {
    path: 'admin',
    loadChildren: () => import("./feature/admin/admin.module").then(result => result.AdminModule).catch(error => setJsChunkError()),
    canActivate: [LoginGuard],

  },
  {
    path: 'siteapprovaldetails',
    component: SiteRequestDetailsComponent,
    canActivate: [LoginGuard]
  },
  {
    path: 'approvals',
    canActivate: [LoginGuard],
    loadChildren: () => import("./feature/approvals/approvals.module").then(module => module.ApprovalsModule).catch(error => setJsChunkError())
  },
  {
    path: 'travelrequest',
    canActivate: [LoginGuard],
    loadChildren: () => import("./feature/pre-trip/Modules/pre-trip-request-history/pre-trip-request-history.module").then(m => m.PreTripRequestHistoryModule).catch(error => setJsChunkError())
  },
  {
    path: 'createtravelrequest',
    loadChildren: () => import("./feature/pre-trip/Modules/pre-trip-request/pre-trip-request.module").then(m => m.PreTripRequestModule).catch(error => setJsChunkError()),
    canActivate: [LoginGuard],
  },
  {
    path: 'sendtraveldetails',
    loadChildren: () => import("./feature/pre-trip/Modules/pre-trip-send-details/pre-trip-send-details.module").then(m => m.PreTripSendDetailsModule).catch(error => setJsChunkError()),
    canActivate: [LoginGuard],
  },
  {
    path: 'traveldetails',
    loadChildren: () => import("./feature/pre-trip/Modules/pre-trip-request-details/pre-trip-request-details.module").then(module => module.PreTripRequestDetailsModule).catch(error => setJsChunkError()),
    canActivate: [LoginGuard],
  },
  {
    path: 'travelapprovaldetails',
    loadChildren: () => import("./feature/pre-trip/Modules/pre-trip-approval-details/pre-trip-approval-details.module").then(module => module.PreTripApprovalDetailsModule).catch(error => setJsChunkError()),
    canActivate: [LoginGuard]
  },
  {
    path: 'userguide',
    canActivate: [LoginGuard],
    loadChildren: () => import("./feature/user-guide/user-guide.module").then(module => module.UserGuideModule).catch(error => setJsChunkError())
  },
  {
    path: 'dashboard',
    canActivate: [LoginGuard],
    loadChildren: () => import("./feature/dashboard/dashboard.module").then(module => module.DashboardModule).catch(error => setJsChunkError())
  },
  {
    path: 'contacttracing',
    canActivate: [LoginGuard, IsInternalUserGuard],
    loadChildren: () => import("./feature/contact-tracing/contact-tracing.module").then(module => module.ContactTracingModule).catch(error => setJsChunkError()),
  },
  {
    path: 'mycertifications',
    loadChildren: () => import("./feature/my-certifications/my-certifications.module").then(module => module.MyCertificationsModule).catch(error => setJsChunkError()),
    canActivate: [LoginGuard, IsInternalUserGuard],
  },
  {
    path: 'countryinformation',
    canActivate: [LoginGuard],
    loadChildren: () => import("./feature/pre-trip-country-information/pre-trip-country-information.module").then(module => module.PreTripCountryInformationModule).catch(error => setJsChunkError())
  },
  {
    path: '**',
    component: PageNotFoundComponent,
  }

];
